export default __webpack_public_path__ + "static/media/phone.1ce7e8ad.png";